import axios from "axios";

function payoutApiBase() {
  const base = process.env.VUE_APP_BASE_URL || "/api/v1";
  return base.replace(/\/v1\/?$/, "/payout");
}

/**
 * System performance banner data (shared backend config id: performance-status).
 */
export async function getPerformanceStatus() {
  const url = `${payoutApiBase()}/performance-status`;
  const { data } = await axios.get(url);
  return data?.result ?? data?.data ?? null;
}
